import "./App.css";
import ReactForm from "./components/ReactForm";

function App() {
  return (
    <div className="App">
      <ReactForm></ReactForm>
    </div>
  );
}

export default App;
